import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ListItemText from '@material-ui/core/ListItemText';
import HelpIcon from '@material-ui/icons/Help';

import { PopoverWrapper } from 'components';

import useStyles from './styles';

const CustomChartLegend = ({
  legendData,
  legendTitle,
  titleDescription,
  helpText,
  legendColors
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.chartLegend}>
      {legendTitle && (
        <Typography className={classes.legendTitle}>{legendTitle}</Typography>
      )}
      {titleDescription && (
        <div className={classes.descriptionWrapper}>
          <Typography>{t(titleDescription)}</Typography>
          {helpText && (
            <PopoverWrapper text={t(helpText)}>
              <HelpIcon className={classes.chipsHelpIcon} />
            </PopoverWrapper>
          )}
        </div>
      )}
      <List component="nav" className={classes.root} aria-label="contacts">
        {legendData.map((item, index) => {
          return (
            <ListItem key={index} className={classes.legendItem}>
              <ListItemIcon className={classes.listIcon}>
                {item.name !== 'noData' && (
                  <FiberManualRecordIcon
                    style={{
                      fill: legendColors[item.name]
                    }}
                  />
                )}
              </ListItemIcon>
              <ListItemText
                className={classes.itemName}
                primary={t(item.legendTitle)}
              />
              {item.name !== 'noData' && (
                <ListItemText primary={`${item.value}%`} />
              )}
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default CustomChartLegend;
